import React from 'react';
import * as PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { parse as parseUrl } from 'url';
import { connect } from '../../connect';
import { createJoinGroupMembership, createFollowGroupMembership, getCountryAbbreviation } from '../../actions';
import { FaithlifeFamilySites } from '../../components/faithlife-family-sites';
import { LoadingIndicator } from '../../components/loading-indicator';
import { RegisterForm } from '../../components/register-form';
import { shouldOptInToMarketingEmailByDefault } from '../../helpers/mailing-lists';
import logger from '../../utils/logger';
import '../../styles/sign-in-register.less';
import { formatUrl } from '../../utils/url';
import { IAuthState } from '../../reducers/auth-reducers';
import { ISignInLocationState } from '../../reducers/location-services-reducers';
import { IReduxProps } from '../../actions/action-types';

function mapStateToProps({ auth, signInLocation }, { location: { search } }) {
	const { returnUrl } = parseUrl(search, true).query;
	return { auth, signInLocation, returnUrl };
}

interface IRegisterPageProps extends IReduxProps {
	auth: IAuthState;
	signInLocation: ISignInLocationState;
	location: URL;
	returnUrl?: string;
}

@connect(mapStateToProps)
export default class RegisterPage extends React.Component<IRegisterPageProps> {
	static contextTypes = {
		router: PropTypes.object.isRequired,
	};

	componentDidMount() {
		const { auth, returnUrl, dispatch } = this.props;
		const el = document.getElementById('app');
		if (el) {
			el.classList.add('RegisterPage');
		}
		if (auth.user.id !== '-1') {
			this.context.router.history.push(returnUrl || '/');
		}
		dispatch(getCountryAbbreviation());
	}

	componentWillReceiveProps(nextProps: IRegisterPageProps) {
		const {
			auth: nextAuth,
			location: { search: nextSearch },
			dispatch: nextDispatch,
		} = nextProps;
		if (!nextAuth.isProcessing && nextAuth.user && nextAuth.user.id !== '-1') {
			if (nextSearch) {
				const { groupMembershipId: groupId, groupMembershipAction: action } = parseUrl(nextSearch, true).query;

				if (groupId && action === 'join') {
					nextDispatch(createJoinGroupMembership(groupId, true)).catch(logger.error);
				} else if (groupId && action === 'follow') {
					nextDispatch(createFollowGroupMembership(groupId, true)).catch(logger.error);
				}
			}
			this.context.router.history.push(this.props.returnUrl || '/');
		}
	}

	componentWillUnmount() {
		const el = document.getElementById('app');
		if (el) {
			el.classList.remove('RegisterPage');
		}
	}

	_createUrl(baseUrl: string) {
		let url = baseUrl;
		const {
			location: { search },
		} = this.props;
		if (search) {
			const query = parseUrl(search, true).query;
			url = formatUrl(url, query);
		}
		return url;
	}

	render() {
		const {
			signInLocation: { isFetching, countryAbbreviation },
			location,
		} = this.props;
		const url = this._createUrl('/signin');

		if (isFetching) {
			return <LoadingIndicator />;
		}

		return (
			<div className="register-page">
				<div className="background" />
				<div className="container">
					<div className="centered">
						<h2 className="centered-title">Create Account</h2>
						<FaithlifeFamilySites />
						<RegisterForm
							location={location}
							emailOptInDefault={shouldOptInToMarketingEmailByDefault(countryAbbreviation)}
							className="centered"
						/>
						<div className="centered-bottom-text">
							or <Link to={url}>Sign In</Link> with your Faithlife / Logos account
						</div>
					</div>
				</div>
			</div>
		);
	}
}
